"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const store_1 = require("../../../store/store");
const html_1 = require("../../../helpers/html");
const ehdSlice_1 = require("../../../store/slices/ehdSlice");
const InputField_1 = __importDefault(require("../../../components/InputField/InputField"));
const RadioInput_1 = __importDefault(require("./RadioInput"));
const Label_1 = require("../../../components/Label");
const themes_1 = require("@radix-ui/themes");
const react_icons_1 = require("@radix-ui/react-icons");
const createAnswerData = (answer, parentId, { id, type }) => ({
    id,
    type,
    parentId,
    answer,
});
const QuestionField = ({ question, parentId }) => {
    var _a, _b;
    const dispatch = (0, store_1.useAppDispatch)();
    const allAnswers = (0, store_1.useAppSelector)((state) => state.ehd.answers);
    const currentAnswer = (0, store_1.useAppSelector)((state) => (0, ehdSlice_1.getCurrentAnswerByQuestionId)(state)(question.id));
    const { setFieldValue, touched, errors } = (0, formik_1.useFormikContext)();
    const ehdShowQuestionBlockingText = (0, store_1.useAppSelector)((state) => { var _a, _b; return (_b = (_a = state.app.appSettings) === null || _a === void 0 ? void 0 : _a.ehdShowQuestionBlockingText) !== null && _b !== void 0 ? _b : false; });
    if (!question)
        return null;
    const upsertAnswer = (value) => {
        const answers = [...allAnswers];
        const newAnswer = createAnswerData(value, parentId, question);
        if (currentAnswer && currentAnswer.index !== -1) {
            answers[currentAnswer.index] = newAnswer;
        }
        else {
            answers.push(newAnswer);
        }
        dispatch((0, ehdSlice_1.setAnswers)(answers));
        setFieldValue(`answer-${question.id}`, value);
    };
    const { id, questionText, type, answerStatusIfYes, answerStatusIfNo, answerStatusIfYesNoMaybe, blockingText, } = question;
    const name = `answer-${id}`;
    const yesNoMaybe = type === 'YES_NO_MAYBE';
    const yesNoQuestion = type === 'YES_NO' || yesNoMaybe;
    const isInvalid = !!(touched[name] && errors[name]);
    const errorId = `${id}-error`;
    let answerStatus;
    switch (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.answer) {
        case 'YES':
            answerStatus = answerStatusIfYes;
            break;
        case 'NO':
            answerStatus = answerStatusIfNo;
            break;
        case 'MAYBE':
            answerStatus = answerStatusIfYesNoMaybe;
            break;
        default:
            answerStatus = undefined;
    }
    const blockingTextTypes = ['BLOCK', 'WARNING'];
    const alertStatus = () => {
        const blocking = answerStatus === 'BLOCK';
        return {
            className: blocking ? 'callout-error' : 'callout-warning',
            textKey: blocking ? 'ehd.alert-block' : 'ehd.alert-warning',
        };
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "pt-3 pb-2", children: (0, jsx_runtime_1.jsx)(Label_1.Label, { id: `${name}-label`, className: "py-2", htmlFor: name, dangerouslySetInnerHTML: (0, html_1.createMarkup)(questionText) }) }), yesNoQuestion && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { role: "group", "aria-labelledby": `${name}-label`, className: `p-2 radio-group ${isInvalid ? 'invalid' : ''}`, children: [(0, jsx_runtime_1.jsx)(RadioInput_1.default, { id: `${name}-yes`, name: name, value: "YES", label: "Ja", onChange: () => upsertAnswer('YES'), isInvalid: isInvalid }), (0, jsx_runtime_1.jsx)(RadioInput_1.default, { id: `${name}-no`, name: name, value: "NO", label: "Nej", onChange: () => upsertAnswer('NO'), isInvalid: isInvalid }), yesNoMaybe && ((0, jsx_runtime_1.jsx)(RadioInput_1.default, { id: `${name}-maybe`, name: name, value: "MAYBE", label: "Kanske", onChange: () => upsertAnswer('MAYBE'), isInvalid: isInvalid }))] }), ehdShowQuestionBlockingText &&
                        (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.answer) &&
                        answerStatus &&
                        blockingTextTypes.includes(answerStatus) && ((0, jsx_runtime_1.jsx)("div", { className: "py-2", children: (0, jsx_runtime_1.jsxs)(themes_1.Callout.Root, { className: `callout ${(_a = alertStatus()) === null || _a === void 0 ? void 0 : _a.className}`, role: "alert", id: name, children: [(0, jsx_runtime_1.jsx)(themes_1.Callout.Icon, { children: (0, jsx_runtime_1.jsx)(react_icons_1.InfoCircledIcon, {}) }), (0, jsx_runtime_1.jsxs)(themes_1.Callout.Text, { children: [(0, jsx_runtime_1.jsxs)("span", { className: "callout-text-type", children: [" ", __.trans((_b = alertStatus()) === null || _b === void 0 ? void 0 : _b.textKey), " "] }), (0, jsx_runtime_1.jsx)("p", { dangerouslySetInnerHTML: (0, html_1.createMarkup)(blockingText || '') })] })] }) })), isInvalid && ((0, jsx_runtime_1.jsx)("div", { id: errorId, className: "field-error", children: (0, jsx_runtime_1.jsx)(formik_1.ErrorMessage, { name: name, component: "span" }) }))] })), !yesNoQuestion && ((0, jsx_runtime_1.jsx)(InputField_1.default, { tabIndex: "0", name: name, type: "text", onChange: (event) => upsertAnswer(event.target.value), value: (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.answer) || '' }))] }));
};
exports.default = QuestionField;
